// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 20:01:59

export default {
  "id": "bubble-tower-3d",
  "slug": "bubble-tower-3d",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/be1021551994487d8cd6934a9164000c-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/be1021551994487d8cd6934a9164000c/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Bubble Tower 3D",
      "description": "If you're a friend of \"oldschool\" bubbleshooters then you'll love Bubble Tower 3D. Experience this reinvented videogames classic in a comepletely new dimension and an amazing aztec setting! Try to connect at least 3 bubbles of the same color to reach the top of the tower. Not enough action happening? Try out the destructive fireball and watch him do his magic. Let's go and reach the highscore.",
      "instructions": "Experience this reinvented video games classic in a completely new dimension and an amazing aztec setting! Try to connect at least 3 bubbles of the same color to reach the top of the tower.",
      "genres": [
        "Bubble Shooter"
      ],
      "tags": [
        "1player",
        "3d",
        "arcade",
        "bubble",
        "highscore"
      ]
    },
    "zh-CN": {
      "title": "泡泡塔3D",
      "description": "如果你是“复古”泡泡射手的朋友，那么你一定会喜欢泡泡塔3D。在这个全新的维度和令人惊叹的阿兹特克场景中，体验这个重新设计的经典电子游戏！尝试连接至少3个相同颜色的泡泡，以到达塔顶。动作不够刺激？试试破坏性的火球，看看它施展魔法。让我们去打破高分吧！",
      "instructions": "体验这个全新维度和令人惊叹的阿兹特克环境下的经典视频游戏！尝试连接至少3个相同颜色的泡泡，以达到塔顶。",
      "genres": [
        "泡泡射击"
      ],
      "tags": [
        "1玩家",
        "3D",
        "街机",
        "泡泡",
        "高分"
      ]
    },
    "zh-TW": {
      "title": "泡泡塔3D",
      "description": "如果您是「oldschool」泡泡射手的朋友，那麼您會喜歡泡泡塔3D。體驗這款經典的電子遊戲在全新維度和驚人的阿茲特克背景中的重生！試著連接至少3個顏色相同的泡泡，以達到塔頂。還不夠刺激？嘗試毀滅性的火球，觀看他施展魔法。一起來創造高分吧！",
      "instructions": "體驗這個重新打造的電子遊戲經典，在全新維度和驚人的阿茲特克場景中！嘗試連接至少3顆同色泡泡，以達到塔頂。",
      "genres": [
        "泡泡射手"
      ],
      "tags": [
        "1玩家",
        "3D",
        "街機",
        "泡泡",
        "高分"
      ]
    },
    "zh-HK": {
      "title": "泡泡塔3D",
      "description": "如果你是「舊學派」泡泡爆破迷，你就會喜歡《泡泡塔3D》。體驗這款重新定義的電子遊戲經典，在全新維度和驚人的阿茲特克背景中！嘗試連接至少三顆同色的泡泡，以達到塔頂。如果遊戲內容不足夠刺激？試試破壞性的火球，觀看他施展魔法。讓我們努力衝破高分榜！",
      "instructions": "體驗這個重新打造的經典電子遊戲，在全新的維度及驚人的阿茲特克設定中！嘗試至少連接3個同色泡泡，以達到塔頂。",
      "genres": [
        "泡泡射擊"
      ],
      "tags": [
        "1人遊玩",
        "3D",
        "街機",
        "泡泡",
        "最高分"
      ]
    },
    "ja": {
      "title": "バブルタワー3D",
      "description": "「oldschool」のバブルシューターが友達なら、バブルタワー3Dが気に入るはずだ。このリメイクされたビデオゲームのクラシックを全く新しい次元と驚異的なアストゥリアン設定で体験しよう。同じ色の少なくとも3つのバブルを結びつけて、塔の頂上を目指そう。アクションが十分にない？破壊的なファイアボールを試してみて、彼の魔法を見てみよう。ハイスコアを目指して行こう！",
      "instructions": "このリニューアルされたビデオゲームのクラシックを全く新しい次元と驚異的なアステカの設定で体験してください！同じ色の至少3つのバブルを結びつけて塔の頂上を目指してください。",
      "genres": [
        "バブルシューター"
      ],
      "tags": [
        "1プレイヤー",
        "3D",
        "アーケード",
        "バブル",
        "ハイスコア"
      ]
    },
    "ko": {
      "title": "버블타워 3D",
      "description": "\"oldschool\" 툰셔터의 친구라면 Bubble Tower 3D를 사랑할 거야. 완전히 새로운 차원과 놀라운 아즈tek 환경에서 이 재인공된 비디오 게임 클래식을 경험해 보세요! 동일한 색의 최소 3개의 툰셔터를 연결하여 타워의 정상에 올라가려고 해 보세요. 부족한 액션인가? 파괴적인 불구슬을 테스트하고 그가 마법을 펼치는 것을 관찰해 보세요. 높은 스코어를 달성해 보자!",
      "instructions": "이 재해발명된 비디오 게임 클래식을 완전히 새로운 차원과 놀라운 아제tsky 환경에서 경험해 보세요! 같은 색의 최소 3개의 백지를 연결하여 탑의 최상단에 도달하려고 해 보세요!",
      "genres": [
        "버블슈터"
      ],
      "tags": [
        "1플레이어",
        "3D",
        "아케이드",
        "퍼즐",
        "하이스코어"
      ]
    },
    "fr": {
      "title": "Tour de Bulles 3D",
      "description": "Si vous êtes un ami des \"oldschool\" joueurs de Bubble Shooter, vous adorerez Bubble Tower 3D. Expérimentez ce classique de jeu vidéo réinventé dans une dimension complètement nouvelle et un cadre aztèque incroyable ! Essayez de connecter au moins 3 bulles de la même couleur pour atteindre le sommet de la tour. Pas assez d'action ? Essayez la boule de feu destructrice et regardez-lui faire son truc. allons-y et atteignons le record haut.",
      "instructions": "Expériencez ce classique de jeux vidéo réinventé dans une toute nouvelle dimension et un cadre aztèque fascinant ! Essayez de connecter au moins 3 bulles de la même couleur pour atteindre le sommet de la tour.",
      "genres": [
        "Tir de Bulles"
      ],
      "tags": [
        "1 joueur",
        "3D",
        "arcade",
        "bulle",
        "record-high"
      ]
    }
  }
};
